import {
  AudioHighlightMetadata,
  AudioHighlightMetadataType,
} from '@modules/feedback/components/AudioType/types';
import { Theme } from '@mui/material';
import { SentimentName } from 'v2/core/entities/fields';

export const getBookmarkColor = (
  highlight: AudioHighlightMetadata,
  theme: Theme,
): string => {
  if (
    highlight.type === AudioHighlightMetadataType.TrackedKeyword ||
    highlight.type === AudioHighlightMetadataType.KeywordSummary
  ) {
    switch (highlight.sentiment) {
      case SentimentName.POSITIVE:
        return theme.palette.success.light;
      case SentimentName.NEGATIVE:
        return theme.palette.error.light;
      case SentimentName.NEUTRAL:
        return theme.palette.warning.dark;
    }
  }

  if (
    highlight.type === AudioHighlightMetadataType.ReasonSummary ||
    highlight.type === AudioHighlightMetadataType.Reason
  ) {
    return theme.palette.secondary.dark;
  }

  return '#4e4d56';
};
